<template>
    <div>
        <form id="wallet_settings" class="p-4">
            <div class="d-flex justify-content-between align-items-center">
                <div class="custom-control custom-checkbox w-50">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="charge_wallet"
                           name="charge_wallet"
                           v-model="charge_wallet"
                    >
                    <label class="custom-control-label" for="charge_wallet">
                        {{ $t('label.should_settlement_to_wallet') }}
                    </label>
                </div>
                <div class="w-50">
                    <label for="wallet_hashid" v-text="$t('label.wallet_hashid')"></label>
                    <input type="text"
                           class="form-control"
                           id="wallet_hashid"
                           name="wallet_hashid"
                           :disabled="!charge_wallet"
                           v-model="form_data.wallet_hashid"
                    >
                </div>
            </div>
            <button type="button"
                    v-text="$t('btn.submit_changes')"
                    class="btn btn-success mt-5"
                    @click="updateWalletSettings()"
            >
            </button>
        </form>
    </div>
</template>

<script>
    import {collectiveService} from "@/common/api.service";
    import $ from "jquery";

    export default {
        data() {
            return {
                charge_wallet: false,
                form_data: {
                    wallet_hashid: '',
                },
            };
        },
        watch: {
            charge_wallet(value) {
                if (! value) {
                    this.form_data.wallet_hashid = '';
                }
            },
        },
        mounted() {
            let params = {
                gateway_hashid: this.$route.params.hashid,
            };

            collectiveService.get_wallet_settings(params).then(res => {
                if (res.data.data.wallet_hashid) {
                    this.charge_wallet = true;
                    this.form_data.wallet_hashid = res.data.data.wallet_hashid;
                }
            });
        },
        methods: {
            updateWalletSettings() {
                let form = $('#wallet_settings');

                form.validate({
                    rules: {
                        wallet_hashid: {
                            required: () => {
                                return this.charge_wallet;
                            },
                        },
                    },
                });

                if (!form.valid()) {
                    return;
                }

                let params = {
                    gateway_hashid: this.$route.params.hashid,
                    wallet_hashid: this.form_data.wallet_hashid,
                };

                collectiveService.update_wallet_settings(params).then(res => {
                    this.$router.push('/gateways');
                }).catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data);
                    }
                    this.showMsg(form, 'danger', response.data.message);
                });
            },
        },
    }
</script>
